import { atom } from 'recoil';
import { STORE_KEYS } from '../keys';

export const actionPopover = atom<HTMLElement | null>({
  key: STORE_KEYS.SHOPPING_ASSISTANT_ACTION_POPOVER,
  default: null
});
